import { create } from 'zustand';
import { FieldMatchingStore, State } from './field-matching.types';
import { createFiltersSlice } from './slices/filters/filters.store';

const initialState: State = {
  orgId: '',
  isOpenDrawer: false,
};

export const useFieldMatchingStore = create<FieldMatchingStore>()((set, get, mutate) => ({
  ...initialState,
  ...createFiltersSlice(set, get, mutate),
  setOrgId: (orgId: string) => {
    set({ orgId });
  },
  setOpenDrawer: (isOpenDrawer: boolean) => {
    set({ isOpenDrawer });
  },
}));
